import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  PFC_APPLICATION_EDIT,
  PFC_APPLICATION_FORM_ALL,
  PFC_APPLICATION_FORM_CURRENT,
  PFC_APPLICATION_FORM_FIELD_BATCH,
  PFC_APPLICATION_LIST,
  PFC_PAYMENT_ALL,
  PFC_PAYMENT_CONFIRM,
  PFC_PAYMENT_CREATE,
  PFC_PAYMENT_LIST,
  PFC_PAYMENT_PRINCIPAL,
} from '../constants/actionTypes'

const Selectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const pfcApplicationEditSelector = createSelector(Selectors, prop(PFC_APPLICATION_EDIT))

export const pfcApplicationListSelector = createSelector(Selectors, prop(PFC_APPLICATION_LIST))

export const pfcApplicationFormAllSelector = createSelector(Selectors, prop(PFC_APPLICATION_FORM_ALL))

export const pfcApplicationFormCurrentSelector = createSelector(Selectors, prop(PFC_APPLICATION_FORM_CURRENT))

export const pfcApplicationFormFieldByIdSelector = createSelector(Selectors, prop(PFC_APPLICATION_FORM_FIELD_BATCH))

export const pfcPaymentListSelector = createSelector(Selectors, prop(PFC_PAYMENT_LIST))
export const pfcPaymentConfirmSelector = createSelector(Selectors, prop(PFC_PAYMENT_CONFIRM))
export const pfcPaymentCreateSelector = createSelector(Selectors, prop(PFC_PAYMENT_CREATE))
export const pfcPaymentPrincipalSelector = createSelector(Selectors, prop(PFC_PAYMENT_PRINCIPAL))
export const pfcPaymentAllSelector = createSelector(Selectors, prop(PFC_PAYMENT_ALL))
